export default __webpack_public_path__ + "static/media/accc.17b61b65.png";